'use strict';
angular.module('ringbaPortal')
  .directive('campaignStats', function() {
    return {
      restrict: 'E',
      scope: {
        type: '<',
        subId: '<',
        panelName: '@'
      },
      controller: 'StatsController',
      controllerAs: 'vm',
      bindToController: true,
      templateUrl: '/scripts/shared/directives/campaign-stats/campaign-stats.view.html'
    };
  });
